import { useState } from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { Textarea } from '@factorialco/f0-react/dist/experimental'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type SurveyStepProps = {
  onClose: () => void
  moduleName: string
}

const SurveyStep = ({ onClose, moduleName }: SurveyStepProps) => {
  const [selectedReason, setSelectedReason] = useState<string>('')
  const [otherReason, setOtherReason] = useState<string>('')

  const surveyOptions = [
    { value: 'product_demo', label: i18n.t('self_upsell.survey_step.options.product_demo') },
    { value: 'too_expensive', label: i18n.t('self_upsell.survey_step.options.too_expensive') },
    {
      value: 'not_sure_if_it_fits_our_needs',
      label: i18n.t('self_upsell.survey_step.options.not_sure_if_it_fits_our_needs'),
    },
    {
      value: 'just_wanted_to_explore',
      label: i18n.t('self_upsell.survey_step.options.just_wanted_to_explore'),
    },
    {
      value: 'had_issues_completing_the_payment',
      label: i18n.t('self_upsell.survey_step.options.had_issues_completing_the_payment'),
    },
    { value: 'other_reason', label: i18n.t('self_upsell.survey_step.options.other_reason') },
  ]

  const handleSubmit = () => {
    track(trackingEvents.upsell.submitSelfUpsellDissmisReason, {
      module: moduleName,
      reason: selectedReason,
      other_reason: otherReason,
      component: 'self_upsell_upgrade_modal',
    })
    app.setFlash({
      type: 'correct',
      message: i18n.t('self_upsell.survey_step.submit_success'),
    })
    onClose()
  }

  const handleSkip = () => {
    track(trackingEvents.upsell.skipSelfUpsellDissmisReason, {
      module: moduleName,
      component: 'self_upsell_upgrade_modal',
    })

    onClose()
  }

  return (
    <F0Dialog
      isOpen
      onClose={handleSkip}
      title={i18n.t('self_upsell.survey_step.title')}
      primaryAction={{
        label: i18n.t('self_upsell.survey_step.submit'),
        onClick: handleSubmit,
        disabled: !selectedReason,
      }}
      secondaryAction={{
        label: i18n.t('self_upsell.survey_step.skip'),
        onClick: handleSkip,
      }}
    >
      <Box gap="s32">
        <Box gap="s16">
          <Text.Normal size="200" color="grey800">
            {i18n.t('self_upsell.survey_step.description')}
          </Text.Normal>
          <Box gap="s8">
            {surveyOptions.map((option, index) => (
              <Box key={index} gap="s16" flexDirection="row" alignItems="center">
                <RadioButton
                  checked={selectedReason === option.value}
                  onChange={(e) => setSelectedReason(e.target.value)}
                  value={option.value}
                  size="small"
                />
                <Text.Normal size="200" color="black">
                  {option.label}
                </Text.Normal>
              </Box>
            ))}
            {selectedReason === 'other_reason' && (
              <Box gap="s16">
                <Textarea
                  label={i18n.t('self_upsell.survey_step.other_reason_label')}
                  value={otherReason}
                  onChange={(value) => setOtherReason(value)}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </F0Dialog>
  )
}

export default SurveyStep
